import { render, staticRenderFns } from "./UserNameLabel.vue?vue&type=template&id=e732cac2&scoped=true"
import script from "./UserNameLabel.vue?vue&type=script&lang=js"
export * from "./UserNameLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e732cac2",
  null
  
)

export default component.exports